// extracted by mini-css-extract-plugin
module.exports = {"offer-slider__text":"offer-slider__text","offerSliderText":"offer-slider__text","offer-slide":"offer-slide","offerSlide":"offer-slide"};